import { cloneDeep, isEmpty, omitBy } from 'lodash';
import { CHAT_AGENT_ACTION_PROPS } from './eventActionsUtils';

const { METADATA, DATA, STATUS } = CHAT_AGENT_ACTION_PROPS;

export const cleanEventBeforeSending = event => {
    const cleanEvent = cloneDeep(event);
    cleanEvent.actions.forEach((action, index, array) => {
        array[index] = omitBy(
            action,
            (value, key) => key === METADATA || (key === DATA && (isEmpty(value) || isEmpty(action[STATUS])))
        );
    });

    return cleanEvent;
};
